export function makePasswordCyrillicValidation<T>(errorMsg: T) {
  const re = /^[-A-Za-z0-9!!”#$%&*,-./:;<=>?@[\]^_{|}~’'"`()+]+$/iu;

  return (password: string) => (re.test(String(password).toLowerCase()) ? undefined : errorMsg);
}

export function makePasswordUppercaseRequiredValidation<T>(errorMsg: T) {
  const re = /(?=.*?[A-Z])/;

  return (password: string) => (re.test(String(password)) ? undefined : errorMsg);
}

export function makePasswordLowercaseRequiredValidation<T>(errorMsg: T) {
  const re = /(?=.*?[a-z])/;

  return (password: string) => (re.test(String(password)) ? undefined : errorMsg);
}

export function makePasswordNumberRequiredValidation<T>(errorMsg: T) {
  const re = /(?=.*?[0-9])/;

  return (password: string) => (re.test(String(password)) ? undefined : errorMsg);
}

export function makePasswordSpecialRequiredValidation<T>(errorMsg: T) {
  const re = /(?=.*?[!”#$%&*,-./:;<=>?@[\]^_{|}~’'"`()+])/;

  return (password: string) => (re.test(String(password)) ? undefined : errorMsg);
}

export function makeSameValidation<T>(password: string, errorMsg: T) {
  return (newPassword: string) => (newPassword === password ? undefined : errorMsg);
}

export function makeNotSameValidation<T>(password: string, errorMsg: T) {
  return (newPassword: string) => (newPassword !== password ? undefined : errorMsg);
}
